import { render, staticRenderFns } from "./GoProfile.vue?vue&type=template&id=31f271d5&scoped=true&"
import script from "./GoProfile.vue?vue&type=script&lang=ts&"
export * from "./GoProfile.vue?vue&type=script&lang=ts&"
import style0 from "./GoProfile.vue?vue&type=style&index=0&id=31f271d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f271d5",
  null
  
)

export default component.exports